const state = {
	countries: [],
	categories: [],
	carriages: [],
	packages: [],
	containers: [],
	vehicles: [],
	business: [],
	erpTypes: []
}
export default state